import type { EventDto } from '../../api/types';
import { compareIsoLocalDateTime } from '../events/dashboard';
import { isoToDatePart } from '../events/iso';

export function groupEventsByResourceForDate(events: EventDto[], dateKey: string): Map<string, EventDto[]> {
  const map = new Map<string, EventDto[]>();

  for (const e of events) {
    if (e.status !== 'active') continue;
    const d = isoToDatePart(e.startAt);
    if (d !== dateKey) continue;
    const list = map.get(e.resourceId) ?? [];
    list.push(e);
    map.set(e.resourceId, list);
  }

  for (const [k, list] of map.entries()) {
    list.sort((a, b) => compareIsoLocalDateTime(a.startAt, b.startAt));
    map.set(k, list);
  }

  return map;
}
